export default __webpack_public_path__ + "static/RB-w-b2d5586bb3e4a2e5e9765dc19ef99718.png";